"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useParentDomain = void 0;
/**
 * A hook that given a parent of type `Domain<T>` and an adapter
 * of type `(data: T) => U` will return a new domain of type `Domain<U>`
 */
function useParentDomain(_a) {
    var parent = _a.parent, adapter = _a.adapter;
    if (parent.data === null)
        return parent;
    return __assign(__assign({}, parent), { data: adapter(parent.data) });
}
exports.useParentDomain = useParentDomain;
//# sourceMappingURL=use-parent-domain.js.map